package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MediaUploadInitRequest(
    val filename: String,
    @SerialName("content_type") val contentType: String
)

@Serializable
data class UploadPresignedResponse(
    @SerialName("upload_url") val uploadUrl: String,
    @SerialName("file_path") val filePath: String,
    @SerialName("cdn_url") val cdnUrl: String
)

@Serializable
data class MediaUploadInitData(
    @SerialName("asset_id") val assetId: String,
    @SerialName("media_type") val mediaType: String,
    @SerialName("upload") val upload: UploadPresignedResponse
)

@Serializable
data class MediaUploadCompleteRequest(
    @SerialName("asset_id") val assetId: String
)

@Serializable
data class MediaUploadCompleteData(
    @SerialName("asset_id") val assetId: String,
    @SerialName("job_id") val jobId: Int? = null,
    @SerialName("status") val status: String? = null,
    @SerialName("queue") val queue: String? = null
)

